import React, { useCallback } from "react";
import { LinkColumn } from "@roc/ui";
import useRedirectUrl from "../../hooks/useRedirectUrl";

interface InspectionIdProps {
  type: 'inspection' | 'loan' | 'draw';
  id: string;
  value?: string;
  onClick?: (id: string) => void;
}

export default function InspectionsDashboardGridIdCell({ type, id, value, onClick }: InspectionIdProps) {
  const url = useRedirectUrl({ type, id });

  const handleClick = useCallback((event) => {
    event.preventDefault();

    if (onClick && type === 'inspection') {
      onClick(id);
    } else {
      window.open(url);
    }
  }, [type, id, url, onClick]);

  return (
    <LinkColumn
      value={value || id}
      url={'#'}
      onClick={handleClick}
    />
  );
}
